export function PlannerBoxLiterals(t: any) {
    return({
      questions: {
        where: t("questions.where"),
        many:  t("questions.many"),
        when: t("questions.when"),
        desc: t("questions.desc"),
      },
      addReturnTrip: t("addReturnTrip"),
      submitButton:  t("submitButton"),
      form: {
        calendar:{
          bestPrice: t("form.calendar.bestPrice")
        },
        origin: {
          id:  t("form.origin.id"),
          name:  t("form.origin.name"),
          label: t("form.origin.label"),
          msjError: { maintext:  t("form.origin.msjError.maintext"), },
        },
        destination: {
          id:  t("form.destination.label"),
          name: t("form.destination.name"),
          label: t("form.destination.label"),
          msjError: { maintext: t("form.destination.msjError.maintext"), },
        },
        passengers: {
          id: t("form.passengers.id"),
          name: t("form.passengers.name"),
          topPassengers: t("form.passengers.topPassengers"),
          counters: [
            {
              id:  t("form.passengers.counters.0.id"),
              text: t("form.passengers.counters.0.text"),
              desc: t("form.passengers.counters.0.desc"),
              min: t("form.passengers.counters.0.min"),
              max: t("form.passengers.counters.0.max"),
              default: t("form.passengers.counters.0.default"),
            },
            {
              id: t("form.passengers.counters.1.id"),
              text: t("form.passengers.counters.1.text"),
              desc: t("form.passengers.counters.1.desc"),
              min: t("form.passengers.counters.1.min"),
              max: t("form.passengers.counters.1.max"),
              default: t("form.passengers.counters.1.default"),
            },
            {
              id: t("form.passengers.counters.2.id"),
              text: t("form.passengers.counters.2.text"),
              desc: t("form.passengers.counters.2.desc"),
              desc2: t("form.passengers.counters.2.desc2"),
              min: t("form.passengers.counters.2.min"),
              max: t("form.passengers.counters.2.max"),
              default: t("form.passengers.counters.2.default"),
            },
          ],
          literals: {
            passenger: t("form.passengers.literals.passenger"),
            passengers: t("form.passengers.literals.passengers")
          },
        },
        departureDate: {
          id: t("form.departureDate.id"),
          name: t("form.departureDate.name"),
          label: t("form.departureDate.label"),
          type: t("form.departureDate.type")
        },
        departureSchedule: {
          id: t("form.departureSchedule.id"),
          name: t("form.departureSchedule.name"),
          label: t("form.departureSchedule.label"),
          type:  t("form.departureSchedule.type"),
          timeselector: t("form.departureSchedule.timeselector"),
          literals: {
            selector: t("form.departureSchedule.literals.selector"),
            options: [
              { code: t("form.departureSchedule.literals.options.0.code"), text: t("form.departureSchedule.literals.options.0.text")},
              { code: t("form.departureSchedule.literals.options.1.code"), text: t("form.departureSchedule.literals.options.1.text"), selected: true},
              //{ code: optionsCode.ANYTIME, text: 'Cualquier hora' },//Comentado para que no se muestre en el planificado RAASWEB-402
            ],
          },
        },
        arrivalDate: {
          id: t("form.arrivalDate.id"),
          name: t("form.arrivalDate.name"),
          label: t("form.arrivalDate.label"),
          type: t("form.arrivalDate.type")
        },
        arrivalSchedule: {
          id: t("form.arrivalSchedule.id"),
          name: t("form.arrivalSchedule.name"),
          label: t("form.arrivalSchedule.label"),
          type: t("form.arrivalSchedule.type"),
          timeselector: t("form.arrivalSchedule.timeselector"),
          literals: {
            selector: t("form.arrivalSchedule.literals.selector"),
            options: [
              { code: t("form.arrivalSchedule.literals.options.0.code"), text: t("form.arrivalSchedule.literals.options.0.text") },
              { code: t("form.arrivalSchedule.literals.options.1.code"), text: t("form.arrivalSchedule.literals.options.1.text"), selected: true},
              //{ code: optionsCode.ANYTIME, text: 'Cualquier hora' },//Comentado para que no se muestre en el planificado RAASWEB-402
            ],
          },
        },
      },
    })
   
  };